import { render, staticRenderFns } from "./OrderFoodRecordList.vue?vue&type=template&id=109d0402&scoped=true"
import script from "./OrderFoodRecordList.vue?vue&type=script&lang=js"
export * from "./OrderFoodRecordList.vue?vue&type=script&lang=js"
import style0 from "./OrderFoodRecordList.vue?vue&type=style&index=0&id=109d0402&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109d0402",
  null
  
)

export default component.exports